// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_70b00e3c","header":"_9d1ba570","column":"_7862d519","columnShippingReturns":"_a8402d92","titleWithIconContainer":"_5a531961","icon":"_aa500264"};